import React from 'react'

const Main = () => {
    return (
        <div> 
            <div id = "main" class="main">
                <div class="main__container">
                    <div class="main__content">
                        <h1>Hi I'm Shi Han</h1>
                        <h2>NTU Computer Science '24</h2>
                        <p>Aspiring software engineer.</p>
                        <button class="main__btn"><a href="#about">Find Out More</a></button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Main
